import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './pages/login/login.component';
import { GestionesComponent } from './pages/gestiones/gestiones.component';
import { NavbarComponent } from './navbar/navbar.component';
import { AvatarModule } from 'ngx-avatar';
import { HttpClientModule } from '@angular/common/http';
import { DatePickerModule } from '@syncfusion/ej2-angular-calendars';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {NgbPaginationModule, NgbAlertModule} from '@ng-bootstrap/ng-bootstrap';
import * as $ from 'jquery';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { OrderModule } from 'ngx-order-pipe';
import { GestionesHeaderComponent } from './components/gestiones-header/gestiones-header.component';
import { GestionesSidebarCarpetasComponent } from './components/gestiones-sidebar-carpetas/gestiones-sidebar-carpetas.component';
import { GestionesSidebarPrecasComponent } from './components/gestiones-sidebar-precas/gestiones-sidebar-precas.component';
import { GestionesSidebarMenuComponent } from './components/gestiones-sidebar-menu/gestiones-sidebar-menu.component';
import { GestionesOfertacomercialComponent } from './components/gestiones-ofertacomercial/gestiones-ofertacomercial.component';
import { GestionesHeaderPrecaComponent } from './components/gestiones-header-preca/gestiones-header-preca.component';
import { GestionesInfopresolicitudComponent } from './components/gestiones-infopresolicitud/gestiones-infopresolicitud.component';
import { GestionesPdfsComponent } from './components/gestiones-pdfs/gestiones-pdfs.component';
import { GestionesInfoparticipanteComponent } from './components/gestiones-infoparticipante/gestiones-infoparticipante.component';
import { GestionesBurointernoComponent } from './components/gestiones-burointerno/gestiones-burointerno.component';
import { GestionesBuroexternoComponent } from './components/gestiones-buroexterno/gestiones-buroexterno.component';
import { GestionesPoliticasComponent } from './components/gestiones-politicas/gestiones-politicas.component';
import { GestionesAplicaCreditoComponent } from './components/gestiones-aplica-credito/gestiones-aplica-credito.component';
import { GestionesActualizarIngresosComponent } from './components/gestiones-actualizar-ingresos/gestiones-actualizar-ingresos.component';
import { GestionesConsolidacionDeudasComponent } from './components/gestiones-consolidacion-deudas/gestiones-consolidacion-deudas.component';
import { GestionesOfertasPrecalificacionComponent } from './components/gestiones-ofertas-precalificacion/gestiones-ofertas-precalificacion.component';
import { GestionesAlertasComponent } from './components/gestiones-alertas/gestiones-alertas.component';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { TextMaskModule } from 'angular2-text-mask';
import { APP_INITIALIZER } from '@angular/core';
import {
  NgxUiLoaderModule,
  NgxUiLoaderConfig,
  SPINNER,
  POSITION,
  PB_DIRECTION,
  NgxUiLoaderRouterModule,
  NgxUiLoaderHttpModule
} from 'ngx-ui-loader';

// Pagination
import { NgxPaginationModule } from 'ngx-pagination';

import { GestionesComparativaMymComponent } from './components/gestiones-comparativa-mym/gestiones-comparativa-mym.component';
import { GestionesDatosgeneralesPrecalificacionComponent } from './components/gestiones-datosgenerales-precalificacion/gestiones-datosgenerales-precalificacion.component';
import { GestionesPatronesComponent } from './components/gestiones-patrones/gestiones-patrones.component';
import { GestionesProductosComponent } from './components/gestiones-productos/gestiones-productos.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GestionesProductosGeneralComponent } from './components/gestiones-productos-general/gestiones-productos-general.component';
import { ModuloSeguridadComponent } from './pages/modulo-seguridad/modulo-seguridad.component';
import { ModuloSeguridadSidebarComponent } from './components/modulo-seguridad-sidebar/modulo-seguridad-sidebar.component';
// Security Components
import { ListComponent } from './components/seguridad-listado-roles/list/list.component';
import { SecurityProfileFormComponent } from './components/seguridad-creacion-perfil/security-profile-form/security-profile-form.component';
import { SecurityUserListComponent } from './components/seguridad-listado-usuarios/security-user-list/security-user-list.component';
import { SeguridadCreacionPerfilComponent } from './components/seguridad-creacion-perfil/seguridad-creacion-perfil.component';
import { SeguridadCreacionRolComponent } from './components/seguridad-creacion-rol/seguridad-creacion-rol.component';
import { SeguridadListadoRolesComponent } from './components/seguridad-listado-roles/seguridad-listado-roles.component';
import { SeguridadListadoUsuariosComponent } from './components/seguridad-listado-usuarios/seguridad-listado-usuarios.component';

// Permissions

//angular material modules
import {MatDialogModule} from '@angular/material/dialog';

// Local pipes
import { AccentMarkPipe } from './utils/accent-mark.pipe';
import { NullEmptyReplaceTextPipe } from './utils/nullEmptyReplaceTextPipe.pipe';
import { NgxPermissionsModule, NgxPermissionsRestrictStubModule} from 'ngx-permissions';
import { SecurityProvider } from './services/security.service';
import { NoCommaPipe } from './utils/no-comma.pipe';
import {CurrencyPipe} from '@angular/common';
import { ModalCcrComponent } from './components/modal-ccr/modal-ccr.component';
//modulo retención
import { ModuloRetencionSidebarComponent } from './components/modulo-retencion-sidebar/modulo-retencion-sidebar.component';
import { ModuloRetencionComponent } from './pages/modulo-retencion/modulo-retencion.component';
import { RetencionInicativaComponent } from './components/retencion-inicativa/retencion-inicativa.component';
import { RetencionReportesComponent } from './components/retencion-reportes/retencion-reportes.component';
import { ModalConsultaClienteComponent } from './components/modal-consulta-cliente/modal-consulta-cliente.component';
import { ModalTipoProductoComponent } from './components/modal-tipo-producto/modal-tipo-producto.component';
import { GestionesOfertasPrecaTcComponent } from './components/gestiones-ofertas-preca-tc/gestiones-ofertas-preca-tc.component';
import { GestionesInfopresolicitudTcComponent } from './components/gestiones-infopresolicitud-tc/gestiones-infopresolicitud-tc.component';
import { NotfoundComponent } from './pages/notfound/notfound.component';
import { GestionesSidebarPrecasABComponent } from './components/gestiones-sidebar-precas-ab/gestiones-sidebar-precas-ab.component';
import { ModalOtpComponent } from './components/modal-otp/modal-otp.component';
//  Configuracion del Loader
const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsColor: '#FFFFFF',
  bgsOpacity: 0.9,
  bgsPosition: POSITION.bottomCenter,
  bgsSize: 0,
  bgsType: SPINNER.ballSpinClockwiseFadeRotating,
  fgsColor: '#FFFFFF',
  fgsPosition: POSITION.centerCenter,
  fgsSize: 0,
  fgsType: SPINNER.ballSpinClockwiseFadeRotating,
  logoUrl: 'assets/images/general/spinner2.gif',
  logoSize: 120,
  pbColor: '#00aeb3',
  pbDirection: PB_DIRECTION.leftToRight,
  pbThickness: 5,
  text: 'Cargando...',
  textColor: '#FFFFFF',
  textPosition: POSITION.centerCenter,
  overlayColor: 'rgb(14 14 14 / 52%)'
};

export function servicesOnRun(security: SecurityProvider) {
  return () => security.load().then();
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    GestionesComponent,
    NavbarComponent,
    GestionesHeaderComponent,
    GestionesSidebarCarpetasComponent,
    GestionesSidebarPrecasComponent,
    GestionesSidebarMenuComponent,
    GestionesOfertacomercialComponent,
    GestionesHeaderPrecaComponent,
    GestionesInfopresolicitudComponent,
    GestionesPdfsComponent,
    GestionesInfoparticipanteComponent,
    GestionesBurointernoComponent,
    GestionesBuroexternoComponent,
    GestionesPoliticasComponent,
    GestionesAplicaCreditoComponent,
    GestionesActualizarIngresosComponent,
    GestionesConsolidacionDeudasComponent,
    GestionesOfertasPrecalificacionComponent,
    GestionesAlertasComponent,
    GestionesComparativaMymComponent,
    GestionesDatosgeneralesPrecalificacionComponent,
    GestionesPatronesComponent,
    GestionesProductosComponent,
    GestionesProductosGeneralComponent,
    ModuloSeguridadComponent,
    ModuloSeguridadSidebarComponent,
    SeguridadCreacionRolComponent,
    SeguridadListadoRolesComponent,
    SeguridadCreacionPerfilComponent,
    SeguridadListadoUsuariosComponent,
    ListComponent,
    SecurityUserListComponent,
    SecurityProfileFormComponent,
    // Pipes
    AccentMarkPipe,
    NullEmptyReplaceTextPipe,
    NoCommaPipe,
    ModalCcrComponent,
    ModuloRetencionComponent,
    ModuloRetencionSidebarComponent,
    RetencionInicativaComponent,
    RetencionReportesComponent,
    ModalConsultaClienteComponent,
    ModalTipoProductoComponent,
    GestionesOfertasPrecaTcComponent,
    GestionesInfopresolicitudTcComponent,
    NotfoundComponent,
    GestionesSidebarPrecasABComponent,
    ModalOtpComponent,
  ],
  imports: [
    FormsModule,
    Ng2SearchPipeModule,
    OrderModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    DatePickerModule,
    AvatarModule,
    HttpClientModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    TextMaskModule,
    NgxPermissionsModule.forRoot(),
    SweetAlert2Module.forRoot(),
    NgbModule,
    MatDialogModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    NgxUiLoaderRouterModule,
    NgbPaginationModule, NgbAlertModule, NgxPermissionsRestrictStubModule,
  ],
  providers: [
    SecurityProvider,
    CurrencyPipe,
    {
      provide: APP_INITIALIZER,
      useFactory: servicesOnRun,
      multi: true,
      deps: [SecurityProvider]
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
